module.exports = __webpack_public_path__ + "img/banner.d85ae0ee.png";